<template>
  <div class="container img-container">
    <a href="?uid=requisitos-consultores">
      <img class="desktop" src="../../assets/img/Banner-consultores.jpg" alt="">
    </a>  
    <a href="?uid=requisitos-consultores">
      <img class="mobile" src="../../assets/img/Banner-consultores-mobile.jpg" alt="">
    </a>
  </div>
</template>
<style scoped>
  div{
    margin-top: 30px;
    margin-bottom: 30px;
  }
  img{
    border-radius: 10px;
    width: 100%;
    height: auto;
  }
  @media (min-width: 770px){
    .mobile {
      display: none;
    }
    .desktop {
      display: block;
    }
  }
  @media (max-width: 770px){
    .mobile {
      display: block;
    }
    .desktop {
      display: none;
    }
  }
</style>